import { createFileRoute } from "@tanstack/react-router";

import { ResetPasswordRequestPage } from "src/pages/ResetPasswordRequestPage";

export const Route = createFileRoute("/_public/reset-password/")({
  component: ResetPasswordRequestPage,
  ssr: true,
});
